import { useContext } from 'react';

import { ITeleconsentContext, TeleconsentContext } from 'context';

export function useTeleconsent(): ITeleconsentContext {
  return useContext(TeleconsentContext)!;
}
